export interface FormulaVariable {
  key: string;
  label: string;
  description: string;
}

export interface FormulaTemplate {
  id: string;
  name: string;
  variables: FormulaVariable[];
}

export const FORMULA_TEMPLATES: FormulaTemplate[] = [
  {
    id: 'dew-point-c',
    name: 'Dew Point °C',
    variables: [
      { key: 'tc', label: 'Temperature (°C)', description: 'Ambient temperature in Celsius' },
      { key: 'rh', label: 'Relative Humidity (%)', description: 'Relative humidity percentage' },
    ],
  },
  {
    id: 'dew-point-f',
    name: 'Dew Point °F',
    variables: [
      { key: 'tf', label: 'Temperature (°F)', description: 'Ambient temperature in Fahrenheit' },
      { key: 'rh', label: 'Relative Humidity (%)', description: 'Relative humidity percentage' },
    ],
  },
  {
    id: 'dew-point-spread-c',
    name: 'Dew Point Spread °C',
    variables: [
      { key: 'tc', label: 'Temperature (°C)', description: 'Ambient temperature in Celsius' },
      { key: 'rh', label: 'Relative Humidity (%)', description: 'Relative humidity percentage' },
    ],
  },
  {
    id: 'dew-point-spread-f',
    name: 'Dew Point Spread °F',
    variables: [
      { key: 'tf', label: 'Temperature (°F)', description: 'Ambient temperature in Fahrenheit' },
      { key: 'rh', label: 'Relative Humidity (%)', description: 'Relative humidity percentage' },
    ],
  },
];
